import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {first} from "rxjs/operators";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {User} from "../models";
import {DeleteUserDialogComponent} from "./dialog/deleteUserDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {DatatableComponent} from "@swimlane/ngx-datatable";
import {Page} from "../models/page";
import {Items} from "../models/items";
import {RechargeCardSetupComponent} from "../workerRechargeCard/dialog/rechargeCardSetup.component";
import {WorkerRechargeCardService} from "../workerRechargeCard/service/workerRechargeCard.service";
import {WorkerRechargeCard} from "../workerRechargeCard/models/workerRechargeCard";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;
    deleteDialogRef: any;
    filterValue: string;
    page = new Page();
    @ViewChild(DatatableComponent) table: DatatableComponent;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private rechargeCardSetupService: WorkerRechargeCardService,
        private _matSnackBar: MatSnackBar,
        public _matDialog: MatDialog
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;
        this.page.pageNumber = 0;
        this.page.size = 25;

        componentTitleService.clearTitle();
        componentTitleService.addPart('Workers');

        this.translationLoader.loadTranslations(polish, english);

        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.setPage({ offset: 0 });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    showConfirmUserDeleteDialog(user: User) {
        this.deleteDialogRef = this._matDialog.open(DeleteUserDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                user: user,
            },
            width: '350px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.userService.delete(user.id).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.deleteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }

    showRechargeCardSetup(user: User) {
        this.deleteDialogRef = this._matDialog.open(RechargeCardSetupComponent, {
            panelClass: 'recharge-card-setup',
            data      : {
                action : 'show',
                user: user
            },
            width: '750px',
        });

        this.deleteDialogRef.afterClosed()
            .subscribe((response: any) => {
                if (!response) {
                    return;
                }

                this.rechargeCardSetupService.update(response.value.id, response.value).pipe(first())
                    .subscribe(response => {
                        this._matSnackBar.open('Update successful', 'OK', {
                            verticalPosition: 'top',
                            duration        : 5000,
                            panelClass: ['snackbar-success']
                        });
                    }, error => {
                        this._matSnackBar.open('Update error - ' + error, 'OK', {
                            verticalPosition: 'top',
                            duration        : 5000,
                            panelClass: ['snackbar-error']
                        });
                    });
            });
    }

    setPage(pageInfo) {
        this.loadingIndicator = true;
        this.page.pageNumber = pageInfo.offset;

        if (typeof pageInfo.limit === "undefined") {
            pageInfo.limit = this.page.size;
        }

        this.userService.getAllWorkersPaged(pageInfo.offset, pageInfo.limit).pipe(first())
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.total;
                    // this.page = pagedData.page;
                },
                error => {
                    this.alertService.error(error);
                })
    }

    updateFilter(event) {
        this.filterValue = event.target.value.toLowerCase();

        if (this.filterValue.length < 3) {
            return;
        }

        this.loadingIndicator = true;

        this.userService.getAllWorkersBy(this.filterValue).pipe(first())
            .subscribe( (res: Items) => {
                    this.rows = res.items;
                    this.loadingIndicator = false;
                    this.page.totalElements = res.items.length;
                },
                error => {
                    this.alertService.error(error);
                })

        this.table.offset = 0;
    }
}
